import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import CurrentApplicationFlow from '@banking/api/services/current-application-flow';
import { ROUTE_FOR_TERMINAL_STATUS } from '@banking/savings-onboarding-app/utils/signup/route-for-application-status';
import type RouterService from '@ember/routing/router-service';
import { feature } from '@square/ember-features/macros';

export default class ConfirmIdentity extends Route {
  @service currentApplicationFlow!: CurrentApplicationFlow;
  @service router!: RouterService;

  @feature('banking/stop_prefilling_savings_onboarding')
  declare stopPrefilling: boolean;

  redirect() {
    if (this.stopPrefilling) {
      this.router.transitionTo('signup.enter-identity-info');
    } else {
      if (this.currentApplicationFlow?.status) {
        const route =
          ROUTE_FOR_TERMINAL_STATUS[this.currentApplicationFlow.status];
        if (route) {
          this.router.transitionTo(route);
        }
      }
    }
  }
}
